import { ProfileForm } from "./../config/profile";

export function getFormFields() {
    const formFields = {};

    for (let formFieldName in ProfileForm) {
        let { dbField } = ProfileForm[formFieldName];

        if (dbField) {
            formFields[dbField] = formFieldName;
        }
    }

    return formFields;
}

function getParserFormFields() {
    const formFields = {};
    const formAdditionalFields = {};

    for (let formFieldName in ProfileForm) {
        let { dbField, isAdditionalInfo = false, additionalInfoField = false } = ProfileForm[formFieldName];

        if (dbField) {
            formFields[dbField] = formFieldName;
        }

        if (isAdditionalInfo) {
            if (additionalInfoField) {
                formAdditionalFields[additionalInfoField] = formFieldName;
            } else {
                formAdditionalFields[dbField] = dbField;
            }
        }
    }

    return { formFields, formAdditionalFields };
}

export function parseProfile(profileData = {}) {
    const { formFields, formAdditionalFields } = getParserFormFields();

    const parsedData = {};
    for (const dbFieldName in profileData) {
        const fieldName = formFields[dbFieldName];

        if (fieldName) {
            parsedData[fieldName] = profileData[dbFieldName];
        }
    }

    if (profileData["borrower_additional_info"]) {
        const profileDataAdditionalInfo = profileData["borrower_additional_info"];

        for (const dbFieldName in profileDataAdditionalInfo) {
            const fieldName = formAdditionalFields[dbFieldName] || dbFieldName;

            parsedData[fieldName] = profileDataAdditionalInfo[dbFieldName];
        }
    }

    return parsedData;
}

export function getFullName(profile = {}, showMiddleName = false, showSuffix = true) {
    const {
        "representative-last-name": representativeLastName = false,
        "representative-first-name": representativeFirstName = false,
        "representative-middle-name": representativeMiddleName = "",
        "representative-suffix-name": representativeSuffixName = "",
    } = profile;

    let result = false;
    if (representativeLastName && representativeFirstName) {
        const fullname = [representativeFirstName.toLowerCase()];
        if (showMiddleName) {
            fullname.push(representativeMiddleName.toLowerCase());
        }
        fullname.push(representativeLastName.toLowerCase());

        if (showSuffix && representativeSuffixName) {
            if (representativeSuffixName === "JR" || representativeSuffixName === "SR") {
                fullname.pop();
                fullname.push(`${representativeLastName.toLowerCase()},`);
                fullname.push(`${representativeSuffixName.toLowerCase()}.`);
            } else {
                fullname.push(`${representativeSuffixName}`);
            }
        }

        result = fullname.join(" ");
    }

    return result;
}
